import { capitalize } from '@printu/lang-utils';
import BrandIcons from 'app/assets/brands';
import { PrimaryColor } from 'app/assets/brands/Logo';
import { call } from 'app/utils/function';
import { isDevel } from 'app/utils/varia';
export var PlatformType;
(function (PlatformType) {
    PlatformType[PlatformType["Annotely"] = 1] = "Annotely";
    PlatformType[PlatformType["AdobeCloud"] = 2] = "AdobeCloud";
    PlatformType[PlatformType["Dropbox"] = 3] = "Dropbox";
    PlatformType[PlatformType["Box"] = 4] = "Box";
    PlatformType[PlatformType["OneDrive"] = 5] = "OneDrive";
    PlatformType[PlatformType["AmazonS3"] = 6] = "AmazonS3";
    PlatformType[PlatformType["GoogleDrive"] = 7] = "GoogleDrive";
})(PlatformType || (PlatformType = {}));
export const getPlatformTag = (type) => {
    switch (type) {
        case PlatformType.Annotely:
            return 'annotely';
        case PlatformType.AdobeCloud:
            return 'adobe';
        case PlatformType.Dropbox:
            return 'dropbox';
        case PlatformType.Box:
            return 'box';
        case PlatformType.OneDrive:
            return 'onedrive';
        case PlatformType.GoogleDrive:
            return 'google';
        case PlatformType.AmazonS3:
            return 's3';
        default:
            return null;
    }
};
export const Platforms = [
    {
        type: PlatformType.Annotely,
        name: 'Annotely',
        icon: BrandIcons.Annotely,
        color: PrimaryColor,
        active: true,
    },
    {
        type: PlatformType.AdobeCloud,
        name: 'Adobe Cloud',
        icon: BrandIcons.AdobeCloud,
        color: '#DA1F26',
        active: true,
    },
    {
        type: PlatformType.Dropbox,
        name: 'Dropbox',
        icon: BrandIcons.Dropbox,
        color: '#0061FF',
        active: true,
    },
    {
        type: PlatformType.Box,
        name: 'Box',
        icon: BrandIcons.Box,
        color: '#0061D5',
        active: true,
    },
    {
        type: PlatformType.GoogleDrive,
        icon: BrandIcons.GoogleDrive,
        name: 'Google Drive',
        color: '#4285F4',
        active: true,
    },
    {
        type: PlatformType.OneDrive,
        name: 'One Drive',
        icon: BrandIcons.OneDrive,
        color: '#0078D4',
        active: true,
    },
    {
        type: PlatformType.AmazonS3,
        name: 'Amazon S3',
        icon: BrandIcons.AmazonS3,
        color: '#569A31',
        active: false,
    },
];
export const DefaultPlatformType = PlatformType.Annotely;
export const getDefaultPlatform = () => Platforms.find(platformAt => platformAt.type === DefaultPlatformType);
export const getPlatformDetails = (platform) => Platforms.find(item => item.type === platform);
export const isPlatformEnabled = (platformType) => {
    var _a;
    if (platformType === PlatformType.Annotely) {
        return true;
    }
    const platform = getPlatformDetails(platformType);
    if (isDevel) {
        return platform.active;
    }
    const plaformExpiclitlyEnabled = (_a = call(configGet, `integration${capitalize(getPlatformTag(platformType))}Enabled`, false)) !== null && _a !== void 0 ? _a : false;
    return platform.active && plaformExpiclitlyEnabled;
};
